import React, { useContext } from "react";
import { isTokenExpired } from "utils/functions";
import AuthContext from "./authcontext";
import logoutRedirect from "utils/logoutRedirect";
import { APPPACKAGECOOKIE } from "utils/defaults";
import { useParams } from "react-router-dom";
import { CustomPackageID } from "utils/defaults";
// ProtectedRoute(prop.component, prop.access, navbardata, setNavbarData)
const ProtectedRoute = (props) => {
  const TheComponent = props.Component;
  const authContext = useContext(AuthContext);
  let { productid } = useParams();

  // console.log("Protected Route - isAuth", authContext.isAuthenticated);
  // console.log("Protected Route - Expired", authContext);
  // console.log("Component", TheComponent);
  //Log entry URL / Package ID
  const packageURL = sessionStorage.getItem(APPPACKAGECOOKIE);
  if (!packageURL && productid) {
    if (productid === "null") productid = CustomPackageID;
    sessionStorage.setItem(APPPACKAGECOOKIE, productid);
  }

  if (!authContext.isAuthenticated || isTokenExpired(authContext.wt.dt)) {
    return logoutRedirect();
  }

  return <TheComponent />;
};

export default ProtectedRoute;
